// extracted by mini-css-extract-plugin
export default {"card":"UserMessage_card__M0a9N","marked-as-read":"UserMessage_marked-as-read__JCMGm","mark-as-read-button":"UserMessage_mark-as-read-button__b10nr"};